import { estJourFerie } from './reactivite.js';
export const MINUTES_JOURNEE_COMPLETE = 7 * 60;
export function etatJourTemps(jour, minutes, aujourdhui) {
    const js = new Date(`${jour}T12:00:00Z`).getUTCDay();
    if (js === 0 || js === 6 || estJourFerie(jour))
        return 'repos';
    if (jour > aujourdhui)
        return 'a_venir';
    if (minutes >= MINUTES_JOURNEE_COMPLETE)
        return 'complet';
    if (minutes > 0)
        return 'partiel';
    return jour === aujourdhui ? 'a_venir' : 'vide';
}
/** Les jours « AAAA-MM-JJ » d'un mois « AAAA-MM ». */
export function joursDuMois(mois) {
    const [a, m] = mois.split('-').map(Number);
    const n = new Date(Date.UTC(a, m, 0)).getUTCDate();
    return Array.from({ length: n }, (_, i) => `${mois}-${String(i + 1).padStart(2, '0')}`);
}
/** Le calendrier d'un mois, depuis les minutes saisies par jour. Écrit une fois : l'API et le mode démo l'appellent. */
export function calendrierTemps(mois, minutesParJour, aujourdhui) {
    return {
        mois,
        objectifMinutes: MINUTES_JOURNEE_COMPLETE,
        jours: joursDuMois(mois).map((date) => {
            const minutes = minutesParJour.get(date) ?? 0;
            return { date, minutes, etat: etatJourTemps(date, minutes, aujourdhui) };
        }),
    };
}
/**
 * MODIFIER UNE INTERVENTION : son auteur, un administrateur, ou la facturation
 * — tant que sa période n'est pas figée. La facturation corrige ce qu'elle
 * prépare sans renvoyer l'intervenant à sa feuille (US-047) ; écarté : lui
 * laisser seulement signaler l'erreur, ce qui bloquait la clôture du mois sur
 * la disponibilité de l'auteur. Figée (relevé envoyé, ou ligne partie vers
 * Ekivox), seule la facturation la corrige, avec un motif, en régularisation
 * (règle 15). L'administrateur n'y échappe pas : ce qui a été facturé ne se
 * réécrit pas en silence. La base garde la même règle (0090).
 */
export function peutModifierIntervention(input) {
    if (input.figee)
        return input.roles.includes('facturation');
    return input.estAuteur || input.roles.includes('administrateur') || input.roles.includes('facturation');
}
/** Au-delà, ce n'est plus une intervention à plusieurs, c'est une réunion d'équipe. */
export const MAX_PRESENTS = 10;
/**
 * Les autres intervenants présents (DEC-020) : des intervenants de l'équipe,
 * sans l'auteur, qui compte déjà. Rend le refus, ou null (règle 9).
 */
export function refusPresents(presents, auteurId, intervenants) {
    if (presents.length > MAX_PRESENTS)
        return `${MAX_PRESENTS} intervenants présents au plus : retirez-en ${presents.length - MAX_PRESENTS}.`;
    if (presents.includes(auteurId))
        return 'Vous comptez déjà comme auteur : ne vous désignez pas parmi les présents.';
    const inconnu = presents.find((id) => !intervenants.has(id));
    if (inconnu)
        return 'Un des présents n’est pas un intervenant actif de l’équipe : retirez-le de la liste.';
    return null;
}
/** Le refus d'une correction sur une ligne figée, pour qui n'est pas la facturation (règle 9). */
export function refusFigee(f) {
    const jour = new Date(f.le).toLocaleDateString('fr-FR', { timeZone: 'Europe/Paris' });
    return f.par === 'releve'
        ? `Cette intervention figure dans un relevé envoyé le ${jour}. Demandez une régularisation au service facturation.`
        : `Cette intervention est partie vers Ekivox le ${jour}. Demandez une régularisation au service facturation.`;
}
/** Saisit du temps : qui traite les demandes, ou qui facture. */
export function peutSaisirTemps(roles) {
    return roles.some((r) => r === 'intervenant' || r === 'administrateur' || r === 'facturation');
}
/** Lundi de la semaine d'une date « AAAA-MM-JJ ». */
export function lundiDe(jour) {
    const d = new Date(`${jour}T00:00:00Z`);
    const decalage = (d.getUTCDay() + 6) % 7;
    d.setUTCDate(d.getUTCDate() - decalage);
    return d.toISOString().slice(0, 10);
}
export function ajouterJours(jour, n) {
    const d = new Date(`${jour}T00:00:00Z`);
    d.setUTCDate(d.getUTCDate() + n);
    return d.toISOString().slice(0, 10);
}
//# sourceMappingURL=temps.js.map